import { render } from "./exportRegister.vue?vue&type=template&id=be353122&scoped=true"
import script from "./exportRegister.vue?vue&type=script&lang=js"
export * from "./exportRegister.vue?vue&type=script&lang=js"

import "./exportRegister.vue?vue&type=style&index=0&id=be353122&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be353122"],['__file',"src/views/exhibitionManage/components/exportRegister.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "be353122"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('be353122', __exports__)) {
    console.log('reload')
    api.reload('be353122', __exports__)
  }
  
  module.hot.accept("./exportRegister.vue?vue&type=template&id=be353122&scoped=true", () => {
    console.log('re-render')
    api.rerender('be353122', render)
  })

}


export default __exports__